import { CreditCard, Gift } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './TopUpHistoryItem.css';

const TopUpHistoryItem = ({ item }) => {
  const { t } = useTranslation(['chat']);
  const isPurchase = item.source_type === 'purchase';
  const date = new Date(item.transaction_date);
  
  // Format date
  const formattedDate = date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
  
  return (
    <div className="topup-item">
      <div className="topup-icon">
        {isPurchase ? (
          <CreditCard size={20} className="topup-icon-purchase" />
        ) : (
          <Gift size={20} className="topup-icon-grant" />
        )}
      </div>
      <div className="topup-details">
        <div className="topup-header">
          <span className="topup-credits">+{item.credits_amount.toLocaleString()}</span>
          <span className="topup-date">{formattedDate}</span>
        </div>
        <div className="topup-meta">
          {isPurchase ? (
            <>
              <span className="topup-source">{t('chat:credits.stripePurchase')}</span>
              {item.amount_usd > 0 && (
                <span className="topup-amount">${Number(item.amount_usd).toFixed(2)}</span>
              )}
              {item.app_source && (
                <span className="topup-app">{item.app_source}</span>
              )}
            </>
          ) : (
            <>
              <span className="topup-source">{t('chat:credits.adminGrant')}</span>
              {item.grant_type && (
                <span className="topup-grant-type">
                  {t(`chat:credits.grantTypes.${item.grant_type}`, item.grant_type)}
                </span>
              )}
            </>
          )}
        </div>
        {item.grant_reason && (
          <div className="topup-reason">"{item.grant_reason}"</div>
        )}
      </div>
    </div>
  );
};

export default TopUpHistoryItem;

